module.exports = __webpack_public_path__ + "img/melanoma-skin-cancer-leaflet.4dd484c4.jpg";